import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	calendarName: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.name.calendar-name',
		defaultMessage: 'Calendar name',
		description: 'label for calendar name field',
	},
	placeHolder: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.name.place-holder',
		defaultMessage: 'Enter the calendar name...',
		description: 'place holder for calendar textField',
	},
	emptyError: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.name.empty-error',
		defaultMessage: 'Calendar name must not be empty',
		description: 'error message displayed when calendar name is empty',
	},
	requiredField: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.name.required-field',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'required field information',
	},
});
